// extracted by mini-css-extract-plugin
module.exports = {"toggleText":"CanvasLibrary_toggleText__2V4n0","baseOption":"CanvasLibrary_baseOption__D7APW"};